module.exports = __webpack_public_path__ + "img/team-member-02.b981eea9.jpg";